<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data PIC" subTitle="Forms" />

    <CreatePic />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreatePic from "@/components/Pages/Data/Pic/CreatePic.vue";

export default defineComponent({
  name: "CreatePicPage",
  components: {
    PageTitle,
    CreatePic,
  },
});
</script>
